<template>
  <div>
    <AppHeader />
    <div>
      <!-- banner and form -->
      <section class="banner">
        <div class="container">
          <div
            class="banner__image"
            data-aos="fade-left"
            data-aos-duration="1200"
          >
            <img src="../assets/header-image-2.png" alt="Banner image files" />
          </div>
          <div class="banner__form">
            <h2>Stay Productive</h2>
            <h2 class="highlighted" style="color: #d00000">Everytime.</h2>
            <p style="font-size: 20px">
              Taski is the journey to Productivity. From day to day tasks, to
              important life decisions, it covers it all. Access different
              techniques to focus more and increase overall productivity.
            </p>
            <button
              type="button"
              class="btn"
              style="margin: 5px"
              onclick="document.getElementById('how-to-section').scrollIntoView({ behavior: 'smooth' });"
            >
              Get Started
              <i style="margin-left: 5px" class="fa fa-arrow-right" />
            </button>
            <button
              type="button"
              class="btn"
              style="margin: 5px"
              onclick="window.location.href = '/#/how-it-works';"
            >
              Try it now
              <i style="margin-left: 5px" class="fa fa-arrow-right" />
            </button>
          </div>
        </div>
      </section>

      <!-- how it works -->

      <section class="how-to" id="how-to-section">
        <div class="wave-bg"></div>
        <div class="container-bg">
          <div class="container">
            <div class="how-to__text">
              <div class="how-to__text--info">
                <h3>Make better decisions</h3>
                <p style="font-size: 20px">
                  Planning is an essential path to productivity. Taski defines a
                  process which helps you prioritize your tasks and take right
                  decisions. Use Taski to deal with your important decisions.
                </p>

                <router-link
                  to="/how-it-works"
                  style="font-size: 20px; font-weight: bold"
                >
                  See how Taski works
                  <img src="../assets/icon-arrow.svg" alt="icon arrow" />
                </router-link>
              </div>
              <div
                class="how-to__text--card"
                data-aos="fade-right"
                data-aos-duration="1200"
              >
                <!-- <img src="../assets/icon-quotes.svg" alt="icon quotes" class="icon-quotes" /> -->
                <h4 style="color: #b40000">Love for Taski</h4>
                <p style="font-size: 18px">
                  Taski makes task prioritization an ease with it's popular
                  decision making tools. Clean UI and simplicity is what gives
                  it an edge.
                </p>
                <!-- <div class="avatar">
                  <div class="avatar__img">
                    <img src="../assets/avatar-testimonial.jpg" alt />
                  </div>
                  <div>
                    <div>
                      <p style="font-size: 16px;">Mohit Khare</p>
                    </div>
                    <div>
                      <p style="font-size: 12px;">Founder, Taski</p>
                    </div>
                  </div>
                </div>-->
              </div>
            </div>
            <div
              class="how-to__image"
              data-aos="fade-left"
              data-aos-duration="1200"
            >
              <img
                src="../assets/swot_snap.png"
                alt="Banner image productivity"
              />
              <img
                src="../assets/smart_snap.png"
                alt="Banner image productivity"
              />
            </div>
          </div>
        </div>
      </section>

      <section class="how-to">
        <div class="container-bg2">
          <div class="container2">
            <div
              class="how-to__image2"
              data-aos="fade-right"
              data-aos-duration="1200"
            >
              <img
                src="../assets/illustration-4.svg"
                alt="Banner image productivity"
              />
            </div>
            <div class="how-to__text">
              <div class="how-to__text--info">
                <h3>Make Todos Effective</h3>
                <p style="font-size: 20px">
                  Simple Todos keep growing and there is no proper management of
                  tasks, With Taski now manage todos and complete them faster.
                </p>
                <p style="font-size: 20px">
                  Plan with following popular decision making frameworks and
                  many more.
                </p>

                <div class="row" style="margin-left: 10px">
                  <div class="check-list-container">
                    <div class="check-list">
                      <span>
                        <i class="fa fa-check" aria-hidden="true"></i>
                      </span>
                      <a href="#/swot">
                        <strong>S.W.O.T</strong>
                      </a>
                    </div>

                    <div class="check-list">
                      <span>
                        <i class="fa fa-check" aria-hidden="true"></i>
                      </span>
                      <a href="#/moscow">
                        <strong>MoSCoW</strong>
                      </a>
                    </div>

                    <div class="check-list">
                      <span>
                        <i class="fa fa-check" aria-hidden="true"></i>
                      </span>
                      <a href="#/smart">
                        <strong>S.M.A.R.T</strong>
                      </a>
                    </div>
                    <div class="check-list">
                      <span>
                        <i class="fa fa-check" aria-hidden="true"></i>
                      </span>
                      <a href="#/eisen">
                        <strong>Eisenhower Matrix</strong>
                      </a>
                    </div>
                    <div class="check-list">
                      <span>
                        <i class="fa fa-check" aria-hidden="true"></i>
                      </span>
                      <a href="#/rice">
                        <strong>R.I.C.E</strong>
                      </a>
                    </div>
                  </div>

                  <div class="check-list-container">
                    <div class="check-list">
                      <span>
                        <i class="fa fa-check" aria-hidden="true"></i>
                      </span>
                      <a href="#/procon">
                        <strong>Pros & Cons</strong>
                      </a>
                    </div>

                    <div class="check-list">
                      <span>
                        <i class="fa fa-check" aria-hidden="true"></i>
                      </span>
                      <a href="#/ikigai">
                        <strong>Ikigai</strong>
                      </a>
                    </div>

                    <div class="check-list">
                      <span>
                        <i class="fa fa-check" aria-hidden="true"></i>
                      </span>
                      <a href="#/kanban">
                        <strong>Kanban</strong>
                      </a>
                    </div>
                    <div class="check-list">
                      <span>
                        <i class="fa fa-check" aria-hidden="true"></i>
                      </span>
                      <a href="#/product-vision">
                        <strong>Product Vision</strong>
                      </a>
                    </div>
                    <div class="check-list">
                      <span>
                        <i class="fa fa-check" aria-hidden="true"></i>
                      </span>
                      <a href="#/spade">
                        <strong>S.P.A.D.E</strong>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="features">
        <h3 style="font-size: 50px; color: #d40000">Features</h3>
        <div class="top">
          <div class="section">
            <div class="section-part">
              <h3>
                <i style="color: #d40000" class="fas fa-heart feature-icon"></i>
                Multiple frameworks
              </h3>
              <div class="paragraph">
                <p>
                  Taski comes with a number of decision making and productivity
                  frameworks which cater your needs for different problems.
                </p>
              </div>
            </div>
            <div class="section-part">
              <h3>
                <i style="color: #009134" class="fas fa-check"></i> Check-list
              </h3>
              <div class="paragraph">
                <p>
                  Each todo acts like a check-list where you can mark a task as
                  done! Todos support all Unicode characters.
                </p>
              </div>
            </div>
          </div>
          <div class="section">
            <div class="section-part">
              <h3>
                <i style="color: #388bf2" class="fa fa-save"></i> Save & Share
              </h3>
              <div class="paragraph">
                <p>
                  Taski provides ability to easily download your progress as
                  image, markdown or in document format and share the content.
                </p>
              </div>
            </div>
            <div class="section-part">
              <h3>
                <i style="color: #d500f9" class="fa fa-rocket"></i> Build for
                All
              </h3>
              <div class="paragraph">
                <p>
                  Everyone takes decisions in day to day life, it can be both
                  personal and business related. Taski is useful for everyone.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <!-- Access form -->
      <section class="access">
        <div class="container">
          <div class="access__text">
            <h3>Get early access today</h3>
            <p style="font-size: 20px">
              Taski is
              <strong>free</strong> for limited duration.
            </p>
            <p style="font-size: 20px">
              Grab the
              <strong>oppurtunity</strong> and boost your
              <strong>productivity</strong>.
            </p>
            <p style="font-size: 20px">
              Lot of
              <strong>features</strong> coming soon!
            </p>

            <p style="font-size: 20px">
              Support me to make Taski better.
              <br />
              <a
                style="
                  color: black;
                  text-decoration: 1px underline black;
                  font-weight: bold;
                "
                href="https://www.buymeacoffee.com/chHAzigTb"
                >- Buy me a coffee</a
              >
              <br />
              <a
                style="
                  color: black;
                  text-decoration: 1px underline black;
                  font-weight: bold;
                "
                href="https://www.patreon.com/bePatron?u=36253322"
                >- Be a Patron</a
              >
            </p>
          </div>
          <div class="access__form">
            <!-- <form>
              <input
                class="email"
                type="email"
                name="email"
                id="email-access"
                placeholder="email@example.com"
              />
              <input class="btn" type="button" value="Get Started For Free" />
            </form>-->
            <!-- Begin Mailchimp Signup Form -->
            <div>
              <form
                action="https://usetaski.us18.list-manage.com/subscribe/post?u=2974614c11e6abca644007be7&amp;id=3b5ecce493"
                method="post"
                id="mc-embedded-subscribe-form"
                name="mc-embedded-subscribe-form"
                class="validate"
                target="_blank"
                novalidate
              >
                <div id="mc_embed_signup_scroll">
                  <input
                    type="email"
                    value
                    name="EMAIL"
                    class="email"
                    id="mce-EMAIL"
                    placeholder="email address"
                    required
                  />
                  <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                  <div
                    style="position: absolute; left: -5000px"
                    aria-hidden="true"
                  >
                    <input
                      type="text"
                      name="b_2974614c11e6abca644007be7_3b5ecce493"
                      tabindex="-1"
                      value
                    />
                  </div>
                  <div class="clear">
                    <input
                      type="submit"
                      value="Signup to get updates"
                      name="subscribe"
                      id="mc-embedded-subscribe"
                      class="btn button"
                    />
                  </div>
                </div>
              </form>
            </div>

            <!--End mc_embed_signup-->
          </div>
        </div>
      </section>

      <!-- Footer -->
      <footer>
        <div class="container">
          <div class="icon-text">
            <i class="fa fa-2x fa-envelope" alt="icon email"></i>
            <a
              style="color: #fff; font-size: 1.7rem; margin-left: 10px"
              href="mailto:hello@usetaski.com"
              >hello@usetaski.com</a
            >
          </div>
          <div class="socialShare">
            <span class="socialIcons">
              <a
                href="https://twitter.com/intent/tweet?url=https://usetaski.com&text=Boost your productivity with Taski! Join @usetaski and make better decision now!"
                target="_blank"
              >
                <i
                  style="color: #fff"
                  class="fab fa-2x fa-twitter"
                  aria-hidden="true"
                ></i>
              </a>
            </span>

            <span class="socialIcons">
              <a
                href="https://www.facebook.com/sharer/sharer.php?u=usetaski.com"
                target="_blank"
              >
                <i
                  style="color: #fff"
                  class="fab fa-2x fa-facebook-f"
                  aria-hidden="true"
                  target="_blank"
                ></i>
              </a>
            </span>
            <span class="socialIcons">
              <a
                target="_blank"
                style="color: #fff"
                href="https://www.linkedin.com/shareArticle?mini=true&url=https://usetaski.com/"
                onclick="window.open(this.href, 'width=550,height=435');return false;"
              >
                <i class="fab fa-2x fa-linkedin-in" aria-hidden="true"></i>
              </a>
            </span>
          </div>
          <p style="font-size: 1.2rem; font-style: bold">
            Made with
            <i style="color: #fff" class="fas fa-heart heartIcon"></i> by
            <a style="color: #fff" href="https://mohitkhare.me" target="blank"
              >Mohit</a
            >
          </p>

          <p>
            Copyright @
            <a style="color: white" href="https://usetaski.com">Usetaski</a> -
            2021
          </p>
        </div>
      </footer>
      <!-- <AppFooter /> -->
    </div>
  </div>
</template>

<script>
import _ from "../assets/js/prefixfree.min.js";
import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";

export default {
  name: "Kanban",
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      email: "",
    };
  },
  methods: {
    processForm: function () {
      console.log({ email: this.email });
      if (this.email.length > 0) {
        this.$http
          .post("http://localhost:3000/subscribe", {
            email: this.email,
          })
          .then((response) => {
            console.log("Awesome subscribed!");
          });
      }
    },
  },
  created() {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  },
};
</script>

<style scoped>
@import "../assets/css/style.css";

.attribution {
  font-size: 11px;
  text-align: center;
}
.attribution a {
  color: hsl(228, 45%, 44%);
}

#mc_embed_signup {
  background: #fff;
  clear: left;
  font: 14px Helvetica, Arial, sans-serif;
  width: 100%;
}

.features {
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3Crect stroke='%23ffffff' stroke-width='0.81' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cuse fill='%23fafafa' href='%23s' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='2'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23e5e5e5'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%23e0e0e0'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23d40000'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23d40000'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23d40000'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}

.features h3 {
  font-size: 48px;
}

.features .top {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 20px;
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3Crect stroke='%23ffffff' stroke-width='0.81' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cuse fill='%23fafafa' href='%23s' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='2'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23e5e5e5'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%23e0e0e0'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23d40000'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23d40000'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23d40000'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}

.features .top .section {
  width: 35%;
  margin-left: 20px;
  margin-right: 20px;
  padding-top: 30px;
  padding-bottom: 30px;
  background-color: #fefefe;
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3Crect stroke='%23ffffff' stroke-width='0.81' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cuse fill='%23fafafa' href='%23s' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='2'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23e5e5e5'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%23e0e0e0'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23d40000'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23d40000'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23d40000'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}

@media all and (max-width: 769px) {
  .features .top .section {
    width: 275px;
    margin-left: 20px;
    margin-right: 20px;
    padding-top: 30px;
    padding-bottom: 30px;
    background-color: #fefefe;
    background-color: #ffffff;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3Crect stroke='%23ffffff' stroke-width='0.81' width='1' height='1' id='s'/%3E%3Cpattern id='a' width='3' height='3' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cuse fill='%23fafafa' href='%23s' y='2'/%3E%3Cuse fill='%23fafafa' href='%23s' x='1' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s' x='2' y='2'/%3E%3Cuse fill='%23f5f5f5' href='%23s'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='2'/%3E%3Cuse fill='%23f0f0f0' href='%23s' x='1' y='1'/%3E%3C/pattern%3E%3Cpattern id='b' width='7' height='11' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s'/%3E%3Cuse href='%23s' y='5' /%3E%3Cuse href='%23s' x='1' y='10'/%3E%3Cuse href='%23s' x='2' y='1'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='8'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='5' y='2'/%3E%3Cuse href='%23s' x='5' y='6'/%3E%3Cuse href='%23s' x='6' y='9'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='h' width='5' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23ebebeb'%3E%3Cuse href='%23s' y='5'/%3E%3Cuse href='%23s' y='8'/%3E%3Cuse href='%23s' x='1' y='1'/%3E%3Cuse href='%23s' x='1' y='9'/%3E%3Cuse href='%23s' x='1' y='12'/%3E%3Cuse href='%23s' x='2'/%3E%3Cuse href='%23s' x='2' y='4'/%3E%3Cuse href='%23s' x='3' y='2'/%3E%3Cuse href='%23s' x='3' y='6'/%3E%3Cuse href='%23s' x='3' y='11'/%3E%3Cuse href='%23s' x='4' y='3'/%3E%3Cuse href='%23s' x='4' y='7'/%3E%3Cuse href='%23s' x='4' y='10'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='c' width='17' height='13' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23e5e5e5'%3E%3Cuse href='%23s' y='11'/%3E%3Cuse href='%23s' x='2' y='9'/%3E%3Cuse href='%23s' x='5' y='12'/%3E%3Cuse href='%23s' x='9' y='4'/%3E%3Cuse href='%23s' x='12' y='1'/%3E%3Cuse href='%23s' x='16' y='6'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='d' width='19' height='17' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23ffffff'%3E%3Cuse href='%23s' y='9'/%3E%3Cuse href='%23s' x='16' y='5'/%3E%3Cuse href='%23s' x='14' y='2'/%3E%3Cuse href='%23s' x='11' y='11'/%3E%3Cuse href='%23s' x='6' y='14'/%3E%3C/g%3E%3Cg fill='%23e0e0e0'%3E%3Cuse href='%23s' x='3' y='13'/%3E%3Cuse href='%23s' x='9' y='7'/%3E%3Cuse href='%23s' x='13' y='10'/%3E%3Cuse href='%23s' x='15' y='4'/%3E%3Cuse href='%23s' x='18' y='1'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='e' width='47' height='53' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23d40000'%3E%3Cuse href='%23s' x='2' y='5'/%3E%3Cuse href='%23s' x='16' y='38'/%3E%3Cuse href='%23s' x='46' y='42'/%3E%3Cuse href='%23s' x='29' y='20'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='f' width='59' height='71' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23d40000'%3E%3Cuse href='%23s' x='33' y='13'/%3E%3Cuse href='%23s' x='27' y='54'/%3E%3Cuse href='%23s' x='55' y='55'/%3E%3C/g%3E%3C/pattern%3E%3Cpattern id='g' width='139' height='97' patternUnits='userSpaceOnUse' patternTransform='scale(18.7) translate(-946.52 -709.89)'%3E%3Cg fill='%23d40000'%3E%3Cuse href='%23s' x='11' y='8'/%3E%3Cuse href='%23s' x='51' y='13'/%3E%3Cuse href='%23s' x='17' y='73'/%3E%3Cuse href='%23s' x='99' y='57'/%3E%3C/g%3E%3C/pattern%3E%3C/defs%3E%3Crect fill='url(%23a)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23b)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23h)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23c)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23d)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23e)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23f)' width='100%25' height='100%25'/%3E%3Crect fill='url(%23g)' width='100%25' height='100%25'/%3E%3C/svg%3E");
    background-attachment: fixed;
    background-size: cover;
  }
}

.section-part {
  margin-top: 5px;
  margin-bottom: 50px;
}

.features .top .section h3 {
  font-size: 30px;
}

.paragraph {
  font-size: 20px;
  margin-top: 20px;
}
</style>